<template>
  <div class="hotel">
    <audit-temp :final_audit_status="final_audit_status" :final_audit_remark="final_audit_remark" />
    <div class="main">
      <h2 class="title">住宿登记</h2>
      <div class="desc">
        <h4>淄博市委党校</h4>
        <p>地址：山东省淄博市大学城深圳路 2199 号</p>
        <p>联系人：路胜文 18653353707</p>
        <p>房型：双床房 / 大床房</p>
        <p>价格：含单早300元/天；含双早320元/天</p>
        <p><em>注：由于建筑布局，双床房与大床房分别位于不同楼栋。如团队希望同栋住宿，建议选择相同房型。</em></p>
      </div>
      <div class="desc">
        <img src="https://qn5839.htx.cc/uploads/20260724/FhmcKYZRDw_Oy0WYApej1Ei6xxo0.jpg">
        <p style="margin-bottom: 20px;">双床房</p>
        <img src="https://qn5839.htx.cc/uploads/20260724/FnQLZkvXKhgJgklUQe5Jd30A8whO.jpg">
        <p>大床房</p>
      </div>
    </div>
    <template v-if="hotelDisabled">
      <template v-if="reg_team_basic.final_extra_point_status > 1">
        <div class="options">
          <h4>您已经选择参加总决赛的成员并预定了会议酒店</h4>
        </div>
        <div class="member">
          <h4>参加总决赛的成员</h4>
          <ul>
            <li v-for="people of hotel_list" :key="people.id">
              <div class="item" v-if="people.is_hotel === 2">
                <div class="msg">
                  <span>姓名：{{ people.name }}</span>
                  <span>身份证号：{{ people.identity }}</span>
                  <span v-if="people.target_type === 1">学号：{{ people.student_id }}</span>
                  <span v-else>工号：{{ people.work_id }}</span>
                  <span>学校：{{ people.school_name }}</span>
                  <span>学院：{{ people.college }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </template>
      <template v-else>
        <div class="options">
          <h4>您未选择参加总决赛的成员</h4>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="options">
        <h4>请选择是否参加总决赛</h4>
        <el-radio-group v-model="reg_team_basic.hotel_status">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </div>
      <div class="member" v-if="reg_team_basic.hotel_status === 1">
        <h4>请选择参加总决赛的成员并预定酒店（如不需要可选择自己预定的选项）</h4>
        <ul>
          <li v-for="people of hotel_list" :key="people.id">
            <div class="item">
              <div class="choose" @click="onChoose(people.id)">
                <i v-if="people.is_hotel === 2" class="el-icon-check"></i>
              </div>
              <div class="msg">
                <span>姓名：{{ people.name }}</span>
                <span>身份证号：{{ people.identity }}</span>
                <template v-if="people.target_type === 1">
                  <span>身份：学生</span>
                  <span>学号：{{ people.student_id }}</span>
                </template>
                <template v-else>
                  <span>身份：指导教师</span>
                  <span>工号：{{ people.work_id }}</span>
                </template>
                <span>学校：{{ people.school_name }}</span>
                <span>学院：{{ people.college }}</span>
              </div>
              <div class="selects">
                <div class="sel">
                  <h5>入住酒店房型</h5>
                  <el-select size="small" v-model="people.room_type" placeholder="请选择入住酒店房型">
                    <el-option v-for="item in hotel_types" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="sel">
                  <h5>入住酒店时间</h5>
                  <el-select size="small" v-model="people.move_in_time" placeholder="请选择入住酒店时间">
                    <el-option v-for="item in time_types" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="sel">
                  <h5>离开酒店时间</h5>
                  <el-select size="small" v-model="people.leave_time" placeholder="请选择离开酒店时间">
                    <el-option v-for="item in time_types" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>

    <div class="btn">
      <el-button type="primary" icon="el-icon-back" @click="onPrevPage">返回上一项</el-button>
      <el-button v-if="hotelDisabled" type="success" icon="el-icon-circle-check" @click="onSubmit">查看结果</el-button>
      <el-button v-else type="success" icon="el-icon-circle-check" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import AuditTemp from '@/components/AuditTemp'
import { fetchStudentList, submitHotel, fetchHotelList } from '@/service/api'

export default {
  name: 'PageHotel',
  components: {
    AuditTemp
  },
  data () {
    return {
      final_audit_status: 3,
      final_audit_remark: '',
      reg_final_expire: false,
      reg_team_basic: {},
      hotel_list: [],
      hotel_types: [],
      time_types: []
    }
  },
  computed: {
    hotelDisabled () {
      return this.final_audit_status === 5 || this.reg_final_expire
    },
    inputDisabled () {
      return this.final_audit_status === 2 || this.final_audit_status === 4 || this.final_audit_status === 5 || this.reg_final_expire
    }
  },
  methods: {
    onPrevPage () {
      this.$router.push('/training')
    },
    async getStudentList () {
      try {
        const data = await fetchStudentList()
        this.reg_final_expire = data.reg_final_expire
        this.reg_team_basic = data.reg_team_basic
        this.final_audit_status = data.reg_team_basic.final_audit_status
        this.final_audit_remark = data.reg_team_basic.final_audit_remark
      } catch (error) {
        console.log('getStudentList error', error)
      }
    },
    async getHotelList () {
      const res = await fetchHotelList()
      this.hotel_types = res.hotel_type_config
      this.time_types = res.time_type_config
      this.hotel_list = res.list
    },
    onChoose (id) {
      if (this.hotelDisabled) {
        return
      }
      for (const hotel of this.hotel_list) {
        if (id === hotel.id) {
          hotel.is_hotel = hotel.is_hotel === 1 ? 2 : 1
        }
      }
    },
    async onSubmit () {
      if (this.hotelDisabled) {
        if (this.inputDisabled) {
          this.$router.push('/result')
        } else {
          this.$router.push('/submit')
        }
        return
      }

      const hotelData = this.hotel_list.filter(item => item.is_hotel === 2)
      const noRoomType = this.hotel_list.filter(item => item.is_hotel === 2 && !item.room_type)
      const noMoveInTime = this.hotel_list.filter(item => item.is_hotel === 2 && !item.move_in_time)
      const noLeaveTime = this.hotel_list.filter(item => item.is_hotel === 2 && !item.leave_time)

      if (this.reg_team_basic.hotel_status === 1 && hotelData.length < 1) {
        this.$alert('请至少选择1人参加总决赛', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }

      if (noRoomType.length > 0) {
        this.$alert('请为参加参加总决赛选择入住酒店房型，如不需要可选择自己预定的选项', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (noMoveInTime.length > 0) {
        this.$alert('请为参加住宿登记成员选择入住酒店时间', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (noLeaveTime.length > 0) {
        this.$alert('请为参加住宿登记成员选择离开酒店时间', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }

      if (this.reg_team_basic.hotel_status === 1) {
        this.$confirm('确认提交信息吗？ ', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const loading = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.9)'
          })
          await submitHotel({
            hotel_status: this.reg_team_basic.hotel_status,
            hotelData
          })
          loading.close()
          if (this.inputDisabled) {
            this.$router.push('/result')
          } else {
            this.$router.push('/submit')
          }
        }).catch(() => {
          console.log('取消')
        })
      } else {
        const loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.9)'
        })
        await submitHotel({
          hotel_status: this.reg_team_basic.hotel_status,
          hotelData
        })
        loading.close()
        if (this.inputDisabled) {
          this.$router.push('/result')
        } else {
          this.$router.push('/submit')
        }
      }
    }
  },
  async mounted () {
    document.body.style.height = 'auto'
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.9)'
    })
    await this.getStudentList()
    await this.getHotelList()
    loading.close()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
